"use client"

import type React from "react"
import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import GateAssignmentList from "./GateAssignmentList"
import GateAssignmentModal from "./GateAssignmentModal"
import type { GateAssignment } from "./types"

const GateAssignmentContainer: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedAssignment, setSelectedAssignment] = useState<GateAssignment | null>(null)
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleOpenAdd = () => {
    setSelectedAssignment(null)
    setModalOpen(true)
  }

  const handleOpenEdit = (assignment: GateAssignment) => {
    setSelectedAssignment(assignment)
    setModalOpen(true)
  }

  const handleSuccess = () => {
    setModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
      <Breadcrumbs mainTitle="Gate Assignments" parent="Access Control" />
      <Container fluid>
        <Row>
          <Col md="12">
            <GateAssignmentList
              onAdd={handleOpenAdd}
              onEdit={handleOpenEdit}
              refreshTrigger={refreshTrigger}
              onRefresh={() => setRefreshTrigger((prev) => !prev)}
            />
          </Col>
        </Row>

        <GateAssignmentModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          onSuccess={handleSuccess}
          initialData={selectedAssignment}
        />
      </Container>
    </>
  )
}

export default GateAssignmentContainer
